import { globalVariables } from "helper/globalVariables";
import { Button } from "../button";
import { OutlineButton } from "../outlineButton";
import { useMediaQuery } from "react-responsive";
import { PaypalButton } from "helper/images";
import Loader from "../loader";

export const BottomButtons = (props) => {
  const {
    onTapNo,
    onTapYes,
    hyperlinkLabel,
    onTapHyperlink,
    hyperlinkLoading,
    outlineLabel = globalVariables.cancel,
    fullLabel = globalVariables.next,
    position = "sticky",
    extraClass = "",
    disabled = false,
    isPaypalButton = false,
    hasCancelButton = true,
    dogSign = false,
    btnCustomWidth = "w-40 lg:w-44 max-[400px]:w-[115px]",
    isBgTransparent = false,
    icon,
  } = props || {};
  const isMobile = useMediaQuery({ query: "(max-width: 630px)" });
  return (
    <div
      className={`${position} w-full bottom-0 h-20 flex items-center row border border-solid border-gray-300 ${
        isBgTransparent ? "bg-transparent" : "bg-white"
      } ${!isMobile ? "justify-end pr-8 " : "justify-center"} ${extraClass}`}
    >
      {!!hyperlinkLabel && (
        <button onClick={hyperlinkLoading ? () => {} : () => onTapHyperlink()}>
          {hyperlinkLoading ? (
            <div className="mr-6">
              <Loader />
            </div>
          ) : (
            <span className="mr-6 text-base font-semibold text-gray-600">
              {hyperlinkLabel}
            </span>
          )}
        </button>
      )}
      {hasCancelButton && (
        <OutlineButton
          prefix={false}
          icon={icon}
          onClick={onTapNo}
          width={btnCustomWidth}
          label={outlineLabel}
        />
      )}
      <div className="ml-3" />
      {isPaypalButton ? (
        <button
          className="h-11 rounded-lg items-center justify-center bg-[#FFC43A]"
          onClick={onTapYes}
        >
          <PaypalButton className="w-[150px] md:w-[220px] max-[400px]:w-[115px]" />
        </button>
      ) : (
        <div className={dogSign ? "lg:mr-[20%]" : ""}>
          <Button
            onClick={onTapYes}
            disabled={disabled}
            width={btnCustomWidth}
            label={fullLabel}
          />
        </div>
      )}
    </div>
  );
};
